import { dataProps, 
        itemListProps } from './properties'

export const setSaleMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setRedeemSalesDiscountCoupon = (state, payload) => {
    state.props.discount_coupon_id = payload.id
    state.props.discount_coupon_percent = payload.discount_percent
    state.props.discount_coupon_fixed_amount = payload.discount_fixed_amount

    state.props.item_list.forEach(item => {
        item.discount_percent = payload.discount_percent
        item.discount_amount = payload.discount_fixed_amount
    })
}

export const setOverrideSalesDiscount = (state, payload) => {
    state.props.item_list.forEach(item => {
        if(!isNaN(parseFloat(item.net_total)) && parseFloat(item.net_total)>0) {
            item.discount_percent = payload.discount_percent
            item.discount_amount = payload.discount_fixed_amount
        }        
    })
}

export const resetRedeemSalesDiscountCoupon = state => {
    state.props.discount_coupon_id = 0
    state.props.discount_coupon_code = ''
    state.props.discount_coupon_percent = 0

    state.props.item_list.forEach(item => {
        item.discount_percent = 0
        item.discount_amount = 0
    })
}

export const setSaleMasterOutstandingList = (state, payload) => {
    state.outstanding_list = payload
}

export const resetSaleMasterOutstandingList = state => {
    state.outstanding_list = []
}

export const setItemAutocompleteList = (state, payload) => {
    state.item_autocomplete_list = payload
}

export const resetItemAutocompleteList = state => {
    state.item_autocomplete_list = []
}

export const setSaleMasterData = (state, payload) => {
    state.props = payload.response    

    if(state.props.item_list.length === 0) {
        state.props.item_list = []//[JSON.parse(JSON.stringify(itemListProps))]
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
        //
    })

} 

export const setSaleMailTrigger = (state, payload) => {
    state.print.printSrc = payload.master_url+'&sale_id='+payload.id+'&access_token='+payload.access_token+'&subpage=email&pagesize='
    state.print.showPrintWindow = true
}

export const toggleSaleTaxPlacement = state => {
    state.props.item_list.forEach(element => {

        if(element.id === 0) {
            if(state.props.tax_id === 0) {
                element.tailoring_tax_percent = 0
                element.fabric_tax_percent = 0
                element.tax_percent = 0
            } else {
                if(element.tailoring_item_id>0) {

                    let tailoringTaxPercent = 0
                    let fabricTaxPercent = 0
                    let taxPercent = 0
                    
                    if(state.props.tax_percent>0) {
                        element.tailoring_detail.tailoring_and_fabric_tax_percent = state.props.tax_percent
                        element.fabric_detail.tax_percent = state.props.tax_percent
                        element.tailoring_detail.tailoring_tax_percent = state.props.tax_percent

                        tailoringTaxPercent = state.props.tax_percent
                        fabricTaxPercent = state.props.tax_percent
                        taxPercent = state.props.tax_percent
                    } else {
                        taxPercent = parseFloat(element.tailoring_detail.tailoring_and_fabric_tax_percent)
                    
                        let show_item_breakup_in_invoice = element.tailoring_detail.show_item_breakup_in_invoice === 1
                        if(show_item_breakup_in_invoice) {
                            tailoringTaxPercent = parseFloat(element.tailoring_detail.tailoring_tax_percent)
                            fabricTaxPercent = parseFloat(element.fabric_detail.tax_percent)
                            taxPercent = element.fabric_id>0 ? ((tailoringTaxPercent + fabricTaxPercent)/2) : tailoringTaxPercent
                        }     
                    }
                    
                    element.tailoring_tax_percent = tailoringTaxPercent
                    element.fabric_tax_percent = fabricTaxPercent
                    element.tax_percent = taxPercent  

                } else if(element.retail_item_id>0) {
                    if(state.props.tax_percent>0) {
                        element.retail_detail.tax_percent = state.props.tax_percent
                    }
                    let taxPercent = parseFloat(element.retail_detail.tax_percent)
                    element.tax_percent = taxPercent  
                }

            }
        }
    })
}

export const copyNewSaleMasterOrderItem = (state, payload) => {

    let props = payload
    props.id = 0
    
    if(props.work_order_id !== null && props.work_order_id !== undefined && props.work_order_id>0) {
        props.work_order_id = 0
    }
    props.combination_item_list.forEach(item => {
        item.work_order_id = 0
        item.id = 0
    })
    
    let lengthIndex = state.props.item_list.length
    let slNo = 0
    if(state.props.item_list[lengthIndex-1] !== undefined) {
        slNo = (state.props.item_list[lengthIndex-1].sl_no)
    }
    
    if(lengthIndex>0) {
        slNo = slNo + 1;
    }
    
    let key = 0
    state.props.item_list.push(props)
    lengthIndex = state.props.item_list.length
    state.props.item_list[lengthIndex-1].sl_no = (slNo)

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('sale_qty_'+(key-1)).focus()
    }, 300);

}

export const addNewSaleMasterOrderItem = (state, payload) => {

    let props = JSON.parse(JSON.stringify(itemListProps))
    
    if(payload.item_type === 0) {
        
        let tailoringUnitSalePrice = parseFloat(payload.selected_item.base_sales_price)
        let fabricUnitQty = isNaN(parseFloat(payload.required_fabric_unit)) ? 0 : parseFloat(payload.required_fabric_unit)
        let fabricUnitSalePrice = isNaN(parseFloat(payload.fabric_sales_price)) ? 0 : parseFloat(payload.fabric_sales_price)
        
        let taxPercent = parseFloat(payload.selected_item.tailoring_and_fabric_tax_percent)
        let tailoringTaxPercent = 0
        let fabricTaxPercent = 0

        let show_item_breakup_in_invoice = payload.selected_item.show_item_breakup_in_invoice === 1
        if(show_item_breakup_in_invoice) {
            tailoringTaxPercent = parseFloat(payload.selected_item.tailoring_tax_percent)
            fabricTaxPercent = parseFloat(payload.selected_item.selected_fabric.tax_percent)
            taxPercent = payload.selected_item.selected_fabric.id>0 ? ((tailoringTaxPercent + fabricTaxPercent)/2) : tailoringTaxPercent
        }

        props.tailoring_item_id = payload.selected_item.id
        props.tailoring_detail = payload.selected_item
        props.is_combination_tailoring_item = payload.selected_item.is_combination_item === 1
        props.combination_item_list = payload.tailoring_combination_item_list
        props.fabric_id = payload.selected_item.selected_fabric.id
        props.fabric_detail = payload.selected_item.selected_fabric
        props.fabric_unit_qty = fabricUnitQty
        props.tailoring_unit_rate = tailoringUnitSalePrice
        props.fabric_unit_rate = fabricUnitSalePrice
        
        props.show_item_breakup_in_invoice = show_item_breakup_in_invoice
        
        props.tailoring_tax_percent = tailoringTaxPercent
        props.fabric_tax_percent = fabricTaxPercent
        props.tax_percent = taxPercent
        
        props.fabric_actual_rate = isNaN(parseFloat(payload.fabric_actual_rate)) ? 0 : parseFloat(payload.fabric_actual_rate)
        props.fabric_price_fixed = payload.fabric_price_fixed

        state.order_tab = '1'

    } else if(payload.item_type > 0) {
        
        let taxPercent = parseFloat(payload.selected_item.tax_percent)

        props.retail_item_id = payload.selected_item.id
        props.retail_detail = payload.selected_item
        let retailUnitSalePrice = parseFloat(payload.selected_item.sale_price)
        
        if(payload.selected_item.default_retail_fabric_unit && payload.selected_item.default_retail_fabric_unit>0) {
            props.retail_qty = payload.selected_item.default_retail_fabric_unit
            if(payload.selected_item.flat_price>0) {
                retailUnitSalePrice = payload.selected_item.flat_price
            }            
        }

        
        props.retail_unit_rate = retailUnitSalePrice
        props.tax_percent = taxPercent  

        //state.order_tab = '2'
    }

    if(state.props.tax_id === 0) {
        props.tailoring_tax_percent = 0
        props.fabric_tax_percent = 0
        props.tax_percent = 0
    }

    let lengthIndex = state.props.item_list.length
    let slNo = 0
    if(state.props.item_list[lengthIndex-1] !== undefined) {
        slNo = (state.props.item_list[lengthIndex-1].sl_no)
    }
    
    if(lengthIndex>0) {
        slNo = slNo + 1;
    }
    
    let key = 0
    state.props.item_list.push(props)
    lengthIndex = state.props.item_list.length
    state.props.item_list[lengthIndex-1].sl_no = (slNo)

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        if(payload.sale_step_post_qty === 2) {
            document.getElementById('item_search_field'+payload.item_type).focus()
            document.getElementById('item_search_field'+payload.item_type).value = ''
        } else {
            if(document.getElementById('sale_qty_'+(key-1))) {
                document.getElementById('sale_qty_'+(key-1)).focus()
            }        
        }
        
    }, 300);

}

export const setEditNetTotal = state => {
    /*state.props.item_list.forEach(element => {
        let copy = JSON.parse(JSON.stringify(element))
        element.edit_net_total = copy.net_total
    })*/
}

export const editRowCalculations = state => {

    let totalQty = 0
    let saleSubTotal = 0
    let saleDiscountAmount = 0
    let saleTaxableAmount = 0
    let saleTotalTax = 0
    let shippingAndHandling = parseFloat(state.props.shipping_and_handling)
    if(isNaN(shippingAndHandling)) {
        shippingAndHandling = 0
    }
    let adjustment = parseFloat(state.props.adjustment)
    if(isNaN(adjustment)) {
        adjustment = 0
    }
    let saleNetTotal = 0

    state.props.item_list.forEach(element => {

        //check if net total altered
        let alterNetTotal = parseFloat(element.alter_net_total)
        let netTotal = parseFloat(element.net_total)
        if(alterNetTotal<netTotal && alterNetTotal>0) {
            element.alter_net_total = 0
            return
        }
        let increasePercent = 0
        if(alterNetTotal>0) {
            if(netTotal > 0) {
                increasePercent = (((alterNetTotal-netTotal)/netTotal)*100)
            }
        }
        //
        let tailoringQty = parseFloat(element.tailoring_qty)
        let tailoringUnitSalePrice = parseFloat(element.tailoring_unit_rate)
        let extraChargeUnitRate = parseFloat(element.extra_charge_unit_rate)
        console.log("1", tailoringUnitSalePrice)
        let fabricUnitQty = parseFloat(element.fabric_unit_qty)
        let fabricUnitSalePrice = parseFloat(element.fabric_unit_rate)
        
        if(element.fabric_price_fixed && element.fabric_actual_rate !== undefined) {
            fabricUnitSalePrice = ((parseFloat(element.fabric_actual_rate)/fabricUnitQty)).toFixed(2)
            element.fabric_unit_rate = fabricUnitSalePrice
        }
        
        if(fabricUnitSalePrice === 0 && element.tailoring_item_id>0) {
            if(alterNetTotal>0) {
                fabricUnitSalePrice = ((alterNetTotal/100+parseFloat(element.tax_percent))*100)
                element.fabric_unit_rate = fabricUnitSalePrice
            }            
        }
        
        let retailUnitSalePrice = parseFloat(element.retail_unit_rate)
        if(retailUnitSalePrice === 0 && element.retail_item_id>0) {
            retailUnitSalePrice = ((alterNetTotal/100+parseFloat(element.tax_percent))*100)
            element.retail_unit_rate = retailUnitSalePrice
        }
        let retailQty = parseFloat(element.retail_qty)
        
        if(increasePercent>0) {
            tailoringUnitSalePrice = ((increasePercent*tailoringUnitSalePrice)/100)+tailoringUnitSalePrice
            extraChargeUnitRate = ((increasePercent*extraChargeUnitRate)/100)+extraChargeUnitRate
            if(element.tailoring_item_id > 0) { 
                element.tailoring_unit_rate = tailoringUnitSalePrice
                element.extra_charge_unit_rate = extraChargeUnitRate
            } else {
                element.tailoring_unit_rate = 0
            }
            
            fabricUnitSalePrice = ((increasePercent*fabricUnitSalePrice)/100)+fabricUnitSalePrice
            if(element.tailoring_item_id > 0) { 
                element.fabric_unit_rate = fabricUnitSalePrice
            } else {
                element.fabric_unit_rate = 0
            }
            
            retailUnitSalePrice = ((increasePercent*retailUnitSalePrice)/100)+retailUnitSalePrice
            if(element.retail_item_id > 0) { 
                element.retail_unit_rate = retailUnitSalePrice
            } else {
                element.retail_unit_rate = 0
            }
            
            element.alter_net_total = 0
            element.discount_percent = 0
            element.discount_amount = 0
            
        }        
        console.log("2", tailoringUnitSalePrice)
        let extra_amount = parseFloat(element.extra_amount)
        element.extra_amount = isNaN(extra_amount) ? 0 : extra_amount
        extra_amount = element.extra_amount
        
        let tailoringTotal = (tailoringUnitSalePrice*tailoringQty)
        let extraChargeTotal = (extraChargeUnitRate*tailoringQty)+extra_amount
        let fabricTotal = ((fabricUnitQty*fabricUnitSalePrice)*tailoringQty)
        let retailTotal = ((retailQty*retailUnitSalePrice))
        console.log("2.1", tailoringTotal)
        let subTotal = ((fabricTotal + tailoringTotal + extraChargeTotal) + retailTotal)
        element.sub_total = subTotal
        //calculate taxes
        let discountPercent = parseFloat(element.discount_percent)
        if(isNaN(discountPercent)) {
            discountPercent = 0
        }
        let discountAmount = parseFloat(element.discount_amount)
        if(isNaN(discountAmount)) {
            discountAmount = 0
        }
        if(discountPercent>0) {
            discountAmount = (discountPercent*subTotal)/100
        } else if(discountAmount>0) {
            discountPercent = parseFloat(((((discountAmount-subTotal)/subTotal)*100)+100).toFixed(2))
            element.discount_percent = 0
        }
        //end
        /** ITEM LEVEL DISCOUNT **/
        let directTailoringDiscount = 0
        if(element.tailoring_detail !== null) {
            directTailoringDiscount = element.tailoring_detail.discount_percent ? parseFloat(element.tailoring_detail.discount_percent) : 0
        }
        directTailoringDiscount = parseFloat(((directTailoringDiscount*tailoringTotal)/100).toFixed(2))
        let tailoringDiscountAmount = directTailoringDiscount+parseFloat(((discountPercent*tailoringTotal)/100).toFixed(2))
        let extraChargeDiscountAmount = parseFloat(((discountPercent*extraChargeTotal)/100).toFixed(2))
        
        let directFabricDiscount = 0
        if(element.fabric_detail !== null) {
            directFabricDiscount = element.fabric_detail.discount_percent ? parseFloat(element.fabric_detail.discount_percent) : 0            
        }
        directFabricDiscount = parseFloat(((directFabricDiscount*fabricTotal)/100).toFixed(2))
        let fabricDiscountAmount = directFabricDiscount+parseFloat(((discountPercent*fabricTotal)/100).toFixed(2))
        
        let directRetailDiscount = 0
        if(element.retail_detail !== null) {
            directRetailDiscount = element.retail_detail.discount_percent ? parseFloat(element.retail_detail.discount_percent) : 0
        }        
        directRetailDiscount = parseFloat(((directRetailDiscount*retailTotal)/100).toFixed(2))

        let retailDiscountAmount = directRetailDiscount+ parseFloat(((discountPercent*retailTotal)/100).toFixed(2))
        /** END ITEM LEVEL DISCOUNT **/

        let totalLineDiscount = directFabricDiscount + directTailoringDiscount + directRetailDiscount

        element.discount_amount = discountAmount
        element.taxable_total = (subTotal - (discountAmount + totalLineDiscount))
        
        let taxableTotal = parseFloat(element.taxable_total)
        let taxPercent = parseFloat(element.tax_percent)
        let tailoringTaxPercent = 0
        let fabricTaxPercent = 0
        
        element.tailoring_unit_discount_amount = parseFloat((tailoringDiscountAmount/tailoringQty).toFixed(2))
        element.extra_charge_unit_discount_amount = parseFloat((extraChargeDiscountAmount/tailoringQty).toFixed(2))
        element.fabric_unit_discount_amount = parseFloat(((fabricDiscountAmount/fabricUnitQty)/tailoringQty).toFixed(2))
        element.retail_unit_discount_amount = parseFloat((retailDiscountAmount/retailQty).toFixed(2))
        
        let tailoringTaxAmount = (taxPercent*(((tailoringTotal+extraChargeTotal)-(tailoringDiscountAmount+extraChargeDiscountAmount))))/100

        let fabricTaxAmount = (taxPercent*((fabricTotal-fabricDiscountAmount)))/100
        let retailTaxAmount = (taxPercent*((retailTotal-retailDiscountAmount)))/100

        let show_item_breakup_in_invoice = element.show_item_breakup_in_invoice
        if(show_item_breakup_in_invoice) {
            tailoringTaxPercent = parseFloat(element.tailoring_tax_percent)
            fabricTaxPercent = parseFloat(element.fabric_tax_percent)
            taxPercent = element.fabric_id>0 ? ((tailoringTaxPercent + fabricTaxPercent)/2) : tailoringTaxPercent

            tailoringTaxAmount = (tailoringTaxPercent*(((tailoringTotal+extraChargeTotal)-(tailoringDiscountAmount+extraChargeDiscountAmount))))/100
            fabricTaxAmount = (fabricTaxPercent*(fabricTotal-fabricDiscountAmount))/100
        }
        let taxAmount = (tailoringTaxAmount+fabricTaxAmount)+retailTaxAmount

        element.tailoring_tax_amount = tailoringTaxAmount
        element.fabric_tax_amount = fabricTaxAmount
        element.tax_amount = taxAmount

        if(state.props.tax_id === 0) {
            element.tailoring_tax_percent = 0
            element.fabric_tax_percent = 0
            element.tax_percent = 0

            element.tailoring_tax_amount = 0
            element.fabric_tax_amount = 0
            element.tax_amount = 0
        }
        
        element.net_total = parseFloat((taxableTotal+taxAmount).toFixed(2))
        
        //let rowData = JSON.parse(JSON.stringify(element))
        //element.edit_net_total = rowData.net_total
        
        //CALCULATE TOTALS
        if(element.tailoring_item_id>0) {
            totalQty = totalQty + tailoringQty
        } else if(element.retail_item_id>0) {
            totalQty = totalQty + retailQty
        }
        saleSubTotal = subTotal + saleSubTotal
        saleDiscountAmount = saleDiscountAmount + (discountAmount + totalLineDiscount)
        saleTaxableAmount = saleTaxableAmount + taxableTotal
        saleTotalTax = saleTotalTax + taxAmount
        saleNetTotal = saleNetTotal + parseFloat(element.net_total)
        //END
    })

    //state.order_tab = lastItem

    saleNetTotal = shippingAndHandling + adjustment + saleNetTotal
    
    state.props.total_qty = totalQty
    state.props.net_total = saleNetTotal
    state.props.sub_total = saleSubTotal
    state.props.discount_amount = saleDiscountAmount
    state.props.taxable_total = saleTaxableAmount
    state.props.total_tax = saleTotalTax
    state.props.net_total = saleNetTotal

    let totalPaid = parseFloat(state.props.total_paid)
    let balance = (saleNetTotal - totalPaid)
    state.props.balance = balance

}

export const setSaleMasterBalance = (state, payload) => {
    const saleNetTotal = state.props.net_total
    state.props.total_paid = payload
    const totalPaid = parseFloat(state.props.total_paid)
    const balance = (saleNetTotal - totalPaid)
    state.props.balance = balance
}

export const removeSaleMasterItemListRow = (state, payload) => {

    let key = 0
    
    state.props.deleted_item_list.push(state.props.item_list[payload])

    state.props.item_list.splice(payload, 1)

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setSubCategorySaleItemList = (state, payload) => {
    state.items.total_rows = payload.total_rows,
    state.items.item_sub_category_id = payload.item_sub_category_id,
    state.items.item_type = payload.item_type,
    state.items.offset = payload.offset,
    state.items.list = payload.list

    if(payload.list.length > 0) {
        state.showCategoryWindow = true
    }
    state.show_category = []
}

export const setFabricSaleItemList = (state, payload) => {
    state.fabric.total_rows = payload.total_rows,
    state.fabric.list = payload.list
}

export const setSalesExchangeRate = (state, payload) => {
    state.props.exchange_rate = payload
}

export const resetSaleMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setSalePrintWindow = (state, payload) => {
    state.print.printTitle = payload.printTitle
    state.print.printSrc = payload.master_url+'&sale_id='+payload.sale_id+'&access_token='+payload.access_token+'&subpage=print&pageSize='+payload.pageSize
    state.print.showPrintWindow = true
}

export const setWOProcessing = (state, payload) => {
    state.props.item_list[payload.index].wo_processing = payload.status
    if(payload.work_order_id) {
        state.props.item_list[payload.index].work_order_id = payload.work_order_id
    }    
}

export const openWorkOrderPopup = state => {
    state.showWorkOrder = true
}

export const setSalesCostSheet = (state, payload) => {
    state.sales_cost_sheet = payload
}

export const setTrialScheduleList = (state, payload) => {
    state.trial_schedule_list = payload
}

export const mutateSaleOrderItemStatus = (state, payload) => {
    state.props.item_list[payload.key] = payload
    state.props.item_list[payload.key].wo_processing = false
}

export const setSaleItemListLoading = (state, payload) => {
    state.props.item_list_loading = payload
}

export const setSaleDataItemList = (state, payload) => {
    state.props.item_list = payload
}

export const setSaleShortcutInfo = (state, payload) => {
    state.props.id = payload.id
    state.props.sale_number_prefix = payload.sale_number_prefix
    state.props.sale_number = payload.sale_number
}


// WEBPACK FOOTER //
// ./src/store/modules/saleMaster/mutations.js